/**
 * The recipe card: a drink as a grid a bartender reads top to bottom and
 * left to right. Prep across the top (the glass, the ice), the lines down
 * the left, each step of the method in its own column beside the lines it
 * works on, and the garnish last. The same shape for every drink, so the
 * eye learns one layout and training is reading.
 *
 * The book keeps the method as one line of text ("Shake over ice and Fine
 * strain"), so the steps are cut from it here. Every step spans every
 * ingredient: the book does not say which lines each step takes, and a
 * guess would be worse than none.
 */
import { lineText } from "./house.js";
const capital = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);
/**
 * The method as steps, in order. Splits on a full stop, a semicolon, a
 * comma, "then", and an "and" that starts a new capitalised instruction
 * ("Shake over ice and Fine strain"), not one inside a step ("gin and
 * lime").
 */
export function methodSteps(method) {
    return method
        .split(/\s*(?:[.;,]|\bthen\b|\band\s+(?=[A-Z]))\s*/)
        .map((s) => capital(s.trim().replace(/^(?:and|then)\s+/i, "")))
        .filter((s) => s.length > 0);
}
export function recipeCard(spec, ingredients, lines = spec.lines) {
    const prep = [];
    const glass = capital(spec.glass.trim());
    if (glass)
        prep.push(/glass$/i.test(glass) ? glass : `${glass} glass`);
    if (spec.ice.trim() && !/^(none|no ice|-|—)$/i.test(spec.ice.trim()))
        prep.push(`Ice: ${spec.ice.trim()}`);
    const garnish = spec.garnish.trim();
    return {
        prep,
        lines: lines.map((l) => lineText(l, ingredients)),
        steps: methodSteps(spec.method),
        garnish: garnish && !/^(none|-|—)$/i.test(garnish) ? `Garnish: ${garnish}` : null,
    };
}
//# sourceMappingURL=card.js.map